import Component from './sign-up-form';
export default Component;
